// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import OrganizeProducts from '../components/OrganizeProducts';
import {actions as ProductActions} from '../duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    products: state.organizeProducts.products,
    pagination: state.organizeProducts.pagination,
    categories: state.categories.categories,
    currency: state.currency.currency,
    isFetching: state.organizeProducts.isFetching,
    isSorting: state.organizeProducts.isSorting,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ProductActions,
      },
      dispatch
    )
)(OrganizeProducts);
